/* Mobile Menu Production Setup — accordion + logo + footer. Mobile only. */
(function () {

  /* ── accordion ─────────────────────────────────────────────────── */
  function initAccordion() {
    if (window.innerWidth > 900) return;
    document.querySelectorAll('.site-menu .nav-group').forEach(function (group) {
      var parentLink = group.querySelector(':scope > a');
      var submenu = group.querySelector('.submenu');
      if (!parentLink || !submenu) return;
      // initAccordion re-runs on every mobile resize (address bar show/hide);
      // binding twice made a tap open and immediately close the group.
      if (group.dataset.mmBound) return;
      group.dataset.mmBound = 'true';
      if (!parentLink.querySelector('.mm-chevron')) {
        var chev = document.createElement('span');
        chev.className = 'mm-chevron';
        chev.setAttribute('aria-hidden', 'true');
        chev.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        parentLink.appendChild(chev);
      }
      parentLink.addEventListener('click', function (e) {
        if (window.innerWidth > 900) return;
        e.preventDefault();
        var isOpen = group.classList.contains('is-expanded');
        document.querySelectorAll('.site-menu .nav-group.is-expanded').forEach(function (g) { g.classList.remove('is-expanded'); });
        if (!isOpen) group.classList.add('is-expanded');
      });
    });
  }

  /* ── logo injection ────────────────────────────────────────────── */
  function injectLogo() {
    if (window.innerWidth > 900) return;
    var menu = document.querySelector('.site-menu');
    if (!menu || menu.querySelector('.mm-logo')) return;
    var brandImg = document.querySelector('.br-brand img');
    if (!brandImg) return;
    var logoDiv = document.createElement('div');
    logoDiv.className = 'mm-logo';
    var logoImg = document.createElement('img');
    logoImg.src = brandImg.src;
    logoImg.alt = brandImg.alt || 'Center Ice Rinks';
    logoDiv.appendChild(logoImg);
    menu.insertBefore(logoDiv, menu.firstChild);
  }


  /* ── SVG icons ─────────────────────────────────────────────────── */
  var IG   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>';
  var FB   = '<svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>';
  var TW   = '<svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>';
  var PH   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
  var EM   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';

  /* footer: ghost-border CTA + socials (slash divider) + contact icons */
  function buildFooterHTML() {
    return '<a class="mm-cta mm-cta-a2" href="/pages/contact#contact">Start A Rink</a>' +
      '<div class="mm-icons-row mm-icons-a2">' +
        '<div class="mm-soc mm-soc-a2">' +
          '<a href="https://www.instagram.com/center_ice_rinks/" target="_blank" rel="noopener" aria-label="Instagram">' + IG + '</a>' +
          '<a href="https://www.facebook.com/centericerinks/" target="_blank" rel="noopener" aria-label="Facebook">' + FB + '</a>' +
          '<a href="https://x.com/CenterIceRinks" target="_blank" rel="noopener" aria-label="X">' + TW + '</a>' +
        '</div>' +
        '<div class="mm-con mm-con-a2">' +
          '<a href="tel:+19056949767" aria-label="Call">' + PH + '</a>' +
          '<a href="mailto:info@centericerinks.com" aria-label="Email">' + EM + '</a>' +
        '</div>' +
      '</div>';
  }

  function injectFooter() {
    if (window.innerWidth > 900) return;
    var menu = document.querySelector('.site-menu');
    if (!menu || menu.querySelector('.mm-footer')) return;
    var footer = document.createElement('div');
    footer.className = 'mm-footer';
    footer.innerHTML = buildFooterHTML();
    menu.appendChild(footer);
  }

  function handleResize() {
    if (window.innerWidth > 900) {
      var menu = document.querySelector('.site-menu');
      var overlay = document.querySelector('.mobile-overlay');
      if (menu && menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        document.body.classList.remove('menu-open');
        if (overlay) overlay.classList.remove('is-open');
        var hamburger = document.querySelector('.hamburger-icon');
        var closeIc = document.querySelector('.close-icon');
        if (hamburger) hamburger.style.display = '';
        if (closeIc) closeIc.style.display = 'none';
      }
    } else {
      initAccordion(); injectLogo(); injectFooter();
    }
  }

  function init() {
    initAccordion(); injectLogo(); injectFooter();
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
